import BannerTable from './BannerTable';

export default BannerTable;
